import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=3f577b9f&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"
import style0 from "./Widget.vue?vue&type=style&index=0&id=3f577b9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f577b9f",
  null
  
)

export default component.exports